export type MicrosoftFilesProvider = 'onedrive' | 'sharepoint';

export const MICROSOFT_FILES_OAUTH_PROVIDER_KEY = 'onedrive_oauth_provider';

export function isMicrosoftFilesProvider(provider: unknown): provider is MicrosoftFilesProvider {
  return provider === 'onedrive' || provider === 'sharepoint';
}

export function getMicrosoftFilesSourceLabel(provider: unknown): string {
  if (provider === 'sharepoint') {
    return 'SharePoint';
  }
  if (provider === 'onedrive') {
    return 'OneDrive';
  }
  return 'Microsoft Source';
}
